import React from 'react'
import styled from 'styled-components'
import SectionHeader from '../SectionHeader'
import { colors, layout, bp } from '../../../theme'

const Main = styled.section`
  padding: ${layout.section};
`

const Container = styled.div`
  max-width: ${layout.maxWidth};
  margin: auto;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;

  @media (max-width: ${bp.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${bp.mobile}) {
    grid-template-columns: 1fr;
  }
`

const Card = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.line};
  border-top: 4px solid ${colors.green};
  border-radius: ${layout.radius};
  padding: 1.4rem;
  transition: 0.2s ease;

  &:hover {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
    transform: translateY(-3px);
  }

  h3 {
    margin: 0 0 0.85rem;
    font-size: 1.08rem;
    color: ${colors.ink};
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    color: ${colors.slate};
    font-size: 0.9rem;
    line-height: 1.5;
    padding-left: 1.1rem;
    position: relative;
    margin-bottom: 0.35rem;
  }

  li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.55rem;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.yellow};
  }
`

const Specialty = styled.div`
  margin-top: 1.75rem;
  background: ${colors.greenLight};
  border: 1px solid ${colors.line};
  border-radius: ${layout.radius};
  padding: 1.5rem 1.75rem;
  display: flex;
  gap: 1rem;
  align-items: flex-start;

  strong {
    color: ${colors.greenDark};
  }

  p {
    margin: 0;
    color: ${colors.slate};
    line-height: 1.65;
  }

  span {
    font-size: 1.5rem;
    line-height: 1;
  }
`

// Sourced verbatim from the company profile product range (assets/).
const categories = [
  {
    title: 'Laundry & Fabric',
    items: [
      'Supa Handwashing Powder',
      'Machine Wash Liquid & Powder',
      'Fabric Softener',
      'Auto Colours Oxybleach',
      'White Restorer',
      'Pre-spotter & Stain Remover',
    ],
  },
  {
    title: 'Surface & Bathroom',
    items: [
      'Multipurpose Liquid Detergent',
      'Multipurpose Disinfectant',
      'Toilet Bowl Cleaner',
      'Tiles / Terrazzo Cleaner',
      'Mirror & Glass Cleaner',
      'Destainer & Descaler',
    ],
  },
  {
    title: 'Sanitation & Personal Care',
    items: [
      'Disinfectant (Pine / Lavender)',
      'Antiseptic',
      'Hand Sanitizer (Bulk)',
      'Surgical Spirit',
      'Hand Wash Gel',
      'Shower Gel & Hair Shampoo',
    ],
  },
  {
    title: 'Kitchen & Specialty',
    items: [
      'Dishwashing Gel (Lemon)',
      'Oven Cleaner & Descaler',
      'Carpet & Car Shampoo',
      'Power Degreaser',
      'Post-construction Cleaners',
      'Salad Wash (Vegetable Safe)',
    ],
  },
]

const Products = () => (
  <Main id="products">
    <Container>
      <SectionHeader
        kicker="Product Range"
        title="35+ detergents across six categories"
        sub="Manufactured under the trademarked Despar Clean brand — with a specialist strength in hard-water and borehole formulations, and dedicated fumigation chemicals."
      />
      <Grid>
        {categories.map((c) => (
          <Card key={c.title}>
            <h3>{c.title}</h3>
            <ul>
              {c.items.map((i) => (
                <li key={i}>{i}</li>
              ))}
            </ul>
          </Card>
        ))}
      </Grid>

      <Specialty>
        <span>💧</span>
        <p>
          <strong>Built for hard &amp; borehole water.</strong> Most estates, apartments,
          and new developments in Kenya run on borehole water, where conventional brands
          underperform. Despar Clean formulations are engineered specifically for these
          conditions — the credible, value-for-money solution for the country's
          fastest-growing residential and commercial market.
        </p>
      </Specialty>
    </Container>
  </Main>
)

export default Products
